function doesStringContainAny (string, items) {
  return items.some(function (i) {
    return string.indexOf(i) >= 1
  })
}

function externalLinks () {
  var links = [].slice.call(document.querySelectorAll('a'))

  // If the link starts with any of these things, we'll open a 600x300 popup
  // window for them.
  var usePopupPrefixes = [
    'https://twitter.com/intent/tweet?',
    'https://www.facebook.com/sharer.php?',
    'https://www.linkedin.com/shareArticle?',
  ]

  var thisDomain =
    window.location.hostname.indexOf('www.') === 0
      ? window.location.hostname.substr(4)
      : window.location.hostname

  links.forEach(function (link) {
    var href = link.getAttribute('href')

    if (
      !href ||
      href.indexOf('mailto:') >= 0 ||
      doesStringContainAny(href, ['http://', 'https://', '//']) === false
    ) {
      return
    }

    var domain = link.hostname.indexOf('www.') === 0 ? link.hostname.substr(4) : link.hostname

    if (domain !== thisDomain) {
      link.setAttribute('target', '_blank')
      // Add noopener and 'noreferrer' to work around this:
      // https://dev.to/ben/the-targetblank-vulnerability-by-example
      var rel = link.getAttribute('rel')

      if (!rel) {
        // will be null if it is not set
        rel = ''
      }

      link.setAttribute('rel', rel + ' noopener noreferrer')
    }

    // Use a popup for social sharing links.
    for (var prefix of usePopupPrefixes) {
      if (href.indexOf(prefix) === 0) {
        link.addEventListener('click', function (event) {
          event.preventDefault()
          window.open(href, '_blank', 'width=600,height=300,menubar=0,toolbar=0,status=0')
        })

        break
      }
    }
  })
}

function acceptCookies(){
  $('.footer__cookies-policy').removeClass('show-accept-cookies');
  Cookies.set('show-accept-cookies-sian-zeng', 'true', {expires: 3650 });

}

$(function(){
  if ($('body').hasClass('page-animate--entering')) {
    window.onbeforeunload = function(){
      $('body').addClass('page-animate--leaving')
    }

    setTimeout(function(){
      $('body').removeClass('page-animate--entering')
    }, 1);

    setTimeout(function(){
      $('body').addClass('page-animate--complete')
    }, 600);

    var images = new Array()
    function preload() {
      for (i = 0; i < preload.arguments.length; i++) {
        images[i] = new Image()
        images[i].src = preload.arguments[i]
      }
    }
  }
});

function prodGridHover() {

  $('.product-grid__img').hover(function() {

    $(this).parent().children('.product-grid__description').addClass('mouseover');
    $(this).addClass('mouseover');
  }, function() {

    $(this).parent().children('.product-grid__description').removeClass('mouseover');
    $(this).removeClass('mouseover');
  });

  $('.product-grid__description .container .title').hover(function() {

    $(this).parent().parent().parent().parent().children('.product-grid__img').addClass('mouseover');
    $(this).parent().parent().parent().addClass('mouseover');
  }, function() {

    $(this).parent().parent().parent().parent().children('.product-grid__img').removeClass('mouseover');
    $(this).parent().parent().parent().removeClass('mouseover');
  });

  $('.product-grid__description .shop-now').hover(function() {

    $(this).parent().parent().children('.product-grid__img').addClass('mouseover');
    $(this).parent().addClass('mouseover');
  }, function() {

    $(this).parent().parent().children('.product-grid__img').removeClass('mouseover');
    $(this).parent().removeClass('mouseover');
  });

}

$(function(){

  externalLinks()


  // Show automatically accept cookies
  if(Cookies.get('show-accept-cookies-sian-zeng') === undefined){
    $('.footer__cookies-policy').addClass('show-accept-cookies');
  }


  /*============================================================================
  # BAO Variant Options
  ==============================================================================*/
  $('.bao-selectors:not(.color) .options a').click(function(e){

    e.preventDefault();

    $('input[name=id]').val($(this).data('id'));

    $('#ProductPrice').html("<span class='money'>" + $(this).data('price') + "</span>")

    var pageUrl = window.location.origin + window.location.pathname +'?variant=' + $(this).data('id');
    window.history.pushState('', '', pageUrl);

    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    var variantText = $(this).text();
    $(this).parent().parent().find(".currently-selected").text(variantText);
    if ($(this).attr("data-image")) {
      var background = $(this).data("image");
      $(".product__background").fadeOut("slow", function () {
        $(this).css("background-image", "url(" + background + ")");
        $(this).fadeIn("slow");
      });
    }
  })

  $(".bao-selectors").click(function(e){
    $(this).find(".options").slideToggle();
  });

  $('.bao-selectors:not(.color)').each(function(){
    var variantText = $(this).find("a.active").text();
    $(this).parent().parent().find(".currently-selected").text(variantText);
  });

  /*============================================================================
  # body space top for header
  ==============================================================================*/
  var headerHeight = $('header.header').height();
  $('main.main-content').css({
    'padding-top': headerHeight
  });
  $( window ).resize(function() {
    headerHeight = $('header.header').height();
    $('main.main-content').css({
      'padding-top': headerHeight
    });
  });
  /*============================================================================
  # account Forgotton Password
  ==============================================================================*/

  function showRecoverPasswordForm() {
    console.log('buum1');
    $('#RecoverPasswordForm').show();
    $('#CustomerLoginForm').hide();
  }

  function hideRecoverPasswordForm() {
    $('#RecoverPasswordForm').hide();
    $('#CustomerLoginForm').show();
  }

  $('#RecoverPassword').on('click', function(evt) {
    console.log('buum');
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  $('#HideRecoverPasswordLink').on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  if (window.location.hash.indexOf('recover') !== -1 ){
    showRecoverPasswordForm();
  }

  /*============================================================================
  # fadein animations
  ==============================================================================*/

  var loader = setInterval(function() {
    $('.fadein').not('.fadein-active').each(function() {
      if ($(this).offset().top < ($(window).scrollTop() + ($(window).height() * (3 / 3)))) {
        $(this).addClass('fadein-active');
        return false;
      }
      if ($('.fadein-active').length == $('.fadein').length) {
        clearInterval(loader);
      }
    });
  }, 100);

  /*============================================================================
  # Drawers
  ==============================================================================*/

  $('.close-drawers').click(function(e){
    console.log("clicked");
    $('body').removeClass('drawer-left-open').removeClass('drawer-right-open').removeClass('drawer-left2-open').removeClass('drawer-top-open');
    $('.site-nav--has-submenu').children('.site-nav__submenu').removeClass('open-submenu');
    $('.sub-nav').removeClass('open');
    $('.marker').removeClass('open');
  });


  setTimeout(function(){
    $('.close-drawers').click(function(e){
      $('body').removeClass('drawer-left-open').removeClass('drawer-right-open').removeClass('drawer-left2-open').removeClass('drawer-top-open');
      $('.site-nav--has-submenu').children('.site-nav__submenu').removeClass('open-submenu');
      $('.sub-nav').removeClass('open');
      $('.marker').removeClass('open');
    });
  }, 1500);

  $('.open-drawer').click(function(e){
        e.preventDefault(); // disable cart link

        // open the correct drawer, check the other one is shut
        if($(this).data('drawer') == 'left'){
          $('body').removeClass('drawer-right-open').removeClass('drawer-left2-open').toggleClass('drawer-left-open');
        }

        if($(this).data('drawer') == 'right'){
          $('body').removeClass('drawer-left-open').removeClass('drawer-left2-open').toggleClass('drawer-right-open');
        }

        if($(this).data('drawer') == 'left2'){
          $('body').removeClass('drawer-left-open').removeClass('drawer-right-open').toggleClass('drawer-left2-open');
        }
        if($(this).data('drawer') == 'top'){
          $('body').toggleClass('drawer-top-open');
          $(this).toggleClass('open-search--open');
          document.getElementById("desktop-search-input").focus();
        }
      });
  $('.close-search').click(function(e){
    $('.open-search').removeClass('open-search--open');

  });

  $('body').click(function(e){

    if(($('body').hasClass('drawer-left-open') || $('body').hasClass('drawer-left2-open') || $('body').hasClass('drawer-right-open')) && !$(e.target).hasClass('drawer__inner') && !$(e.target).hasClass('open-drawer') && $(e.target).closest('.drawer__inner').length == 0){

      $('body').removeClass('drawer-right-open').removeClass('drawer-left-open').removeClass('drawer-left2-open').removeClass('drawer-top-open');
      $('.sub-nav').removeClass('open');
    }
    $( ".sub-nav" ).click(function( event ) {
      event.stopPropagation();
    });
  });

  $('.close-modal').click(function(){
    $('.modal--overlay').hide();
  });


  /*============================================================================
  <<<<<<<< Modals
  ==============================================================================*/

  $('.modal__close').click(function(e){
    e.preventDefault();
    $('.modal').removeClass('open');
    $('body').removeClass('modal-open');
  });

  $('.modal__open').click(function(e){
    e.preventDefault();
    $('.modal[data-modal='+$(this).data('modal')+']').addClass('open');
    $('body').addClass('modal-open');
  });


  /*============================================================================
  # second level menu for header
  ==============================================================================*/

  $('.site-nav--has-submenu').click(function(e){
    $('.sub-nav').not('.'+$(this).data('sublist')).removeClass('open')
    if($(this).data('sublist') === "sub-nav-contact")
    {
      var $thisContact = $(this);
      var $thisDrawer = $('.'+$(this).data('sublist'));
      if($thisDrawer.hasClass('open')){
       $thisDrawer.find('.column.right').removeClass('open');
       setTimeout(function(){
         $thisDrawer.removeClass('open');
       }, 750);
       if($(window).width() >= 800){
        $('.site-nav--has-submenu').not($(this)).children('.marker').removeClass('open');
      }
    }

    else{
      $thisDrawer.addClass('open');
      setTimeout(function(){
        $thisDrawer.find('.column.right').addClass('open');
      }, 750);
      if($(window).width() >= 800){
        $('.site-nav--has-submenu').not($(this)).children('.marker').removeClass('open');
      }
    }
  }

  else{
    if($(window).width() >= 800){
      $('.site-nav--has-submenu').not($(this)).children('.marker').removeClass('open');
    }
    $('.'+$(this).data('sublist')).toggleClass('open');
  }
});

  // opens second drawer on mobile menu for submenu links

  $('.site-nav--has-submenu').click(function(e){

    $(this).children('.site-nav__submenu').toggleClass('open-submenu');
    $(this).children('.marker').toggleClass('open');

  });

  /*============================================================================
  # Index Page carousel for mobile only for most popular products
  ==============================================================================*/

  if ($(window).width() <= 700){
    var $indexMostPopularCarousel = $('section.most-popular .most-popular-product-grid').flickity({
    // wrapAround: true,
    imagesLoaded: true,
    prevNextButtons: false,
    pageDots: false
  });
    $('.section.most-popular .arrows .arrow.left').on( 'click', function() {
      $indexMostPopularCarousel.flickity('previous');
    });
    $('.section.most-popular .arrows .arrow.right').on( 'click', function() {
      $indexMostPopularCarousel.flickity('next');
    });
  }

  var $instaCarousel = $('.insta__carousel').flickity({
    wrapAround: true,
    cellAlign: "left",
    imagesLoaded: true,
    prevNextButtons: false,
    pageDots: false,
    dragThreshold: 15
  });

  /*============================================================================
  # Product Page
  ==============================================================================*/

  // $(".product__background").swipe( {
  //       //Generic swipe handler for all directions
  //       swipe:function(event, direction, distance, duration, fingerCount, fingerData) {
  //         alert("You swiped " + direction );
  //       },
  //     });

  var $productMobileCarousel = $('.product__background--mobile--carousel').flickity({
    wrapAround: true,
    cellAlign: "left",
    imagesLoaded: true,
    prevNextButtons: false
  });

  // close main product drawer

  $('.vf-ViewFullscreen_Wrapper').click(function(e){
   $('.product__content').toggleClass('hidden');
   $(this).toggleClass('open');
   $('.product__background__featured-image').toggleClass('open');
 });

  $('.description.show-full').click(function(e){
    $('.product__background__featured-image').toggleClass('open');
    $('.product__content-wrapper').toggleClass('move-right');
    $('.product__full-description').toggleClass('desc-full-desc-open');
    $('.product__content').toggleClass('content-full-desc-open');
    $('.icon-close.drawer-toggle__product-form').toggle();

  });

  $('.drawer-toggle__full-description').click(function(e){
    $('.product__background__featured-image').toggleClass('open');
    $('.product__content-wrapper').toggleClass('move-right');
    $('.product__full-description').toggleClass('desc-full-desc-open');
    $('.product__content').toggleClass('content-full-desc-open');
    $('.icon-close.drawer-toggle__product-form').toggle();
  });


  if($(".template-product").length > 0){

    $('.customer-image--carousel').flickity({
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      pageDots: false
    });


    $('.customer-image-magnific').magnificPopup({
      delegate: 'a',
      type: 'image',
      gallery:{
        enabled:true
      }
    });

    var $carouselCustomerImage = $('.customer-image--carousel');

  // previous
  $('.customer-image--next').on( 'click', function() {
    $carouselCustomerImage.flickity('next');
  });
  // previous wrapped
  $('.customer-image--previous').on( 'click', function() {
    $carouselCustomerImage.flickity('previous');
  });

}

if ($(".customer-image--carousel").length > 0){

  $(".customer-image--carousel .product-grid__description a").click(function(e){
    e.preventDefault();
    var goToUrl = $(this).attr("href");
    window.open(goToUrl);
  });

}

  /*============================================================================
  # Index Page
  ==============================================================================*/

  if($('.related-product__carousel').length > 0){
    var $carousel = $('.related-product__carousel');

  // previous
  $('.related--next').on( 'click', function() {
    $carousel.flickity('next');
  });
  // previous wrapped
  $('.related--previous').on( 'click', function() {
    $carousel.flickity('previous');
  });
}

if($('.recently-viewed__carousel').length > 0){
  var $carouselRecent = $('.recently-viewed__carousel');

  // previous
  $('.recently--next').on( 'click', function() {
    $carouselRecent.flickity('next');
  });
  // previous wrapped
  $('.recently--previous').on( 'click', function() {
    $carouselRecent.flickity('previous');
  });
}

if($('.article-index-carousel').length > 0){
  var $carouselArticle = $('.article-index-carousel');

  // previous
  $('.featured-left').on( 'click', function() {
    $carouselArticle.flickity('previous');
  });
  // previous wrapped
  $('.featured-right').on( 'click', function() {
    $carouselArticle.flickity('next');
  });
}

  /*============================================================================
  # Product-Grid hover effects
  ==============================================================================*/

  prodGridHover();

  /*============================================================================
  # Product page change image on click
  ==============================================================================*/
  function getCurrentImageNumber() {
    var defaultBackgroundImage = $('.product__background').css('background-image').match(/\(([^)]+)\)/)[1].replace('https:', '');
    var defaultBackgroundImageShort = defaultBackgroundImage.substring( 0, defaultBackgroundImage.indexOf( "v=" ) ).replace('"','').replace("'", "");
    console.log(defaultBackgroundImageShort);
    $('.all-product-images div').each(function(){
      var thisBackgroundImage = $(this).data('background');
      var thisBackgroundImageShort = thisBackgroundImage.substring( 0, thisBackgroundImage.indexOf( "v=" ) );
      if (thisBackgroundImageShort == defaultBackgroundImage){
      }
    })
  }

  if($('.product__background').length > 0){
    var backgroundNumber = 0;
    var clickerNumber = 0;
    var maxNumber = $('.all-product-images div:last-child').data('number');
    console.log(maxNumber);
    var firstBackground =$('.product__background').css('background-image').match(/\(([^)]+)\)/)[1].replace('https:', '');
  }
  if($('body').hasClass('template-product')){
  //right arrow click
  getCurrentImageNumber();

  var backgroundNumber = 1;
  $('.arrows .arrow.right').click(function(){

    backgroundNumber += 1;
    if(backgroundNumber > maxNumber){
      backgroundNumber = 1;
    }
    var background = $('.all-product-images .image-' + backgroundNumber).data('background');
    if((clickerNumber == 0) && ( firstBackground == background)){
      backgroundNumber = backgroundNumber + 1;
      if(backgroundNumber > maxNumber){
        backgroundNumber = 1;
      }
      background = $('.all-product-images .image-' + backgroundNumber).data('background');

    }
    $(".product__background").fadeOut("slow", function () {
      $(this).css("background-image", "url(" + background + ")");
      $(this).fadeIn("slow");
    });

    $(".product-image-dots .dot").removeClass('is-selected');
    $('.product-image-dots .dot.image-' + backgroundNumber).addClass('is-selected');

    clickerNumber = clickerNumber + 1;
  });
  //left arrow click
  $('.arrows .arrow.left').click(function(){
    backgroundNumber -= 1;
    if(backgroundNumber == 0){
      backgroundNumber = maxNumber;
    }
    var background = $('.all-product-images .image-' + backgroundNumber).data('background');
    if((clickerNumber == 0) && ( firstBackground == background)){
      backgroundNumber = backgroundNumber + 1;
      if(backgroundNumber > maxNumber){
        backgroundNumber = 1;
      }
      background = $('.all-product-images .image-' + backgroundNumber).data('background');
    }
    $(".product__background").fadeOut("slow", function () {
      $(this).css("background-image", "url(" + background + ")");
      $(this).fadeIn("slow");
    });

    $(".product-image-dots .dot").removeClass('is-selected');
    $('.product-image-dots .dot.image-' + backgroundNumber).addClass('is-selected');

    clickerNumber = clickerNumber + 1;
  });
}



  // toggle social share

  $('.form-info-wrapper .element.share').click(function(){
    $('.social-sharing').fadeToggle();
  });
  /*============================================================================
  # Flickity article instagram plugin
  ==============================================================================*/
  if($('.section-article').length > 0){
    var checkExist = setInterval(function() {
     if ($('#insta-feed a').length) {
      var wrapElements = $("#insta-feed > a");
      for(var i = 0; i < wrapElements.length; i+=4) {
        wrapElements.slice(i, i+4).wrapAll("<div class='element'></div>");
      }
      setTimeout(function(){
        $('#insta-feed').flickity({
          cellAlign: 'left',
          contain: true,
          cellSelector: '.element',
          wrapAround: true
        });
      }, 2000);
      clearInterval(checkExist);
    }
  }, 100);
  }

  $('.article__insta-carousel').flickity({
    cellAlign: 'left',
    contain: true,
    cellSelector: '.element',
    wrapAround: true
  });

  $('.comments-section--open').click(function(){
    console.log("clicked");
    $('.comments-section').slideToggle(1000);
  });

  /*============================================================================
  # FAQ
  ==============================================================================*/

  $('.faq__category').click(function(){
    $(this).siblings(".faq__question--wrapper").slideToggle();
  });


  $('.faq__question').click(function(){
    $(this).siblings(".faq__answer").slideToggle();
  });

/*============================================================================
# Collection custom filters roll down
==============================================================================*/

$('.custom-filters').click(function(e){
  if (e.target !== this)
    return;
  $(".custom-filters").not($(this)).find('.filters-list').hide();
  $(".custom-filters").not($(this)).removeClass('on-top');
  $(this).find('.filters-list').slideToggle();
  $(this).addClass('on-top');
})
$('.filter-li').click(function(){
  $(this).find('.filters__sublist').slideToggle();
  $(this).siblings(".filter-li").removeClass("active");
  $(this).addClass("active");
})

/*============================================================================
# Collection filters dynamically resize select width
==============================================================================*/

// set select size

if($('body').hasClass('template-collection')){
  $("#compute_option").html($('.select-collection select option:selected').text());
  $(".select-collection select").width($("#compute_select").width());

  $('.select-collection select').change(function(){
    $("#compute_option").html($('.select-collection select option:selected').text());
    $(this).width($("#compute_select").width());
  });

// filter  auto resize

$("#compute_option").html($('#SortBy option:selected').text());
$("#SortBy").width($("#compute_select").width());

$('#SortBy').change(function(){
  $("#compute_option").html($('#SortBy option:selected').text());
  $(this).width($("#compute_select").width());
});
}


/*============================================================================
# Blog-Press
==============================================================================*/

$('.grid-press-image').magnificPopup({
  delegate: 'a',
  type: 'image',
  gallery:{
    enabled:true
  }
});

/*============================================================================
# Customer Gallery
==============================================================================*/

$('.gallery-element').magnificPopup({
  delegate: 'a',
  type: 'image',
  gallery:{
    enabled:true
  }
});

})
if($(".section-article #side").length > 0 && $(window).width() >= 980){

  $("#side-wrapper-inner").stick_in_parent({
    parent: '.section-article',
    offset_top: 160

  });

}

/*============================================================================
# Image zoom
==============================================================================*/

$('.img-zoom-container').click(function(ev){

  if (!ev.target.classList.contains('arrow')) {
    $(".img-zoom-lens").toggleClass('zoom-open')
    if ($(".img-zoom-lens").hasClass('zoom-open')) {

      var img, glass, w, h, zoom;
      zoom = 3;

      img = $(".product__background__featured-image")[0];
      glass = $(".img-zoom-lens")[0];

      if (img.style.backgroundImage !== this.style.backgroundImage) {
        img = this;
      }

      glass.style.backgroundImage = img.style.backgroundImage;
      glass.style.backgroundRepeat = "no-repeat";
      glass.style.backgroundSize = (img.offsetWidth * zoom) + "px " + (img.offsetHeight * zoom) + "px";

      w = glass.offsetWidth / 2;
      h = glass.offsetHeight / 2;

      moveMagnifier(ev)

      $(".img-zoom-lens").mousemove(moveMagnifier);
      $(this).mousemove(moveMagnifier);

      function moveMagnifier(e) {
        e.preventDefault();

        var pos, x, y;

        pos = getCursorPos(e);
        x = pos.x;
        y = pos.y;

        if (x > this.offsetWidth - (w / zoom)) {x = this.offsetWidth - (w / zoom);}
        if (x < w / zoom) {x = w / zoom;}
        if (y > this.offsetHeight - (h / zoom)) {y = this.offsetHeight - (h / zoom);}
        if (y < h / zoom) {y = h / zoom;}

        glass.style.backgroundPosition = "-" + ((x * zoom) - w) + "px -" + ((y * zoom) - h) + "px";
      }

      function getCursorPos(e) {
        var a, x = 0, y = 0;
        e = e || window.event;

        a = img.getBoundingClientRect();

        x = e.pageX - a.left;
        y = e.pageY - a.top;

        x = x - window.pageXOffset;
        y = y - window.pageYOffset;
        return {x : x, y : y};
      }
    } else {
      $(this).unbind( "mousemove" )
      $(".img-zoom-lens").unbind( "mousemove" )
    }
  } else if (ev.target.classList.contains('arrow') && $(".img-zoom-lens").hasClass('zoom-open')) {
    $(".img-zoom-lens").removeClass('zoom-open')
    $(this).unbind( "mousemove" )
    $(".img-zoom-lens").unbind( "mousemove" )
  }
})
